import { assocPath, curry, dissocPath, path, pipe } from 'ramda'

const modifyPath = curry(
  (from: string[], to: (string | number)[], obj: Record<string, any>) => {
    const v = path(from, obj)
    return pipe(dissocPath(from), assocPath(to, v))(obj)
  }
)

export default modifyPath

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe('modifyPath', () => {
    it('moves a value from one path to another', () => {
      const source = { a: { b: 1 }, c: 2 }

      expect(modifyPath(['a', 'b'], ['c', 0], source)).toEqual({
        a: {},
        c: [1],
      })
    })

    it('keeps structure when the source path is missing', () => {
      const source = { a: { b: 1 }, c: 2 }

      expect(modifyPath(['a', 'missing'], ['d'], source)).toEqual({
        a: { b: 1 },
        c: 2,
        d: undefined,
      })
    })
  })
}
